import { useCallback, useMemo } from "react";
import { Mixpanel } from "../../utils/mixpanel";

export const useEvents = () => {
  const track = useCallback(
    async (eventName: string, eventProperties?: Record<any, any>) => {
      try {
        await Mixpanel.track(eventName, eventProperties);
      } catch {
        return;
      }
    },
    [],
  );

  const updateUserProfile = useCallback(
    async (userId: number | undefined, profileProperties: Record<any, any>) => {
      if (!userId) return;
      try {
        await Mixpanel.people.set(profileProperties);
      } catch (err) {
        console.log("update err", err);
        return;
      }
    },
    [],
  );

  return useMemo(
    () => ({ track, updateUserProfile }),
    [track, updateUserProfile],
  );
};
